import I18nKeys from 'src/utils/i18n-keys/'
import Misc from 'src/utils/helper/misc'

export default {
  setValidations () {
    this.relateValidationObjects([
      ...this.getSubmissionValidations(),
      ...this.getBinaryValidations()
    ])
  },
  getBinaryValidations () {
    /**
     * @Return {Array}
     */
    let items = []
    this.$store.getters['binaries/list'].map(b => {
      const binaryValidation = b.validationResult?.validations || []
      items = [
        ...items,
        ...this.translateValidationValues(binaryValidation, b.fileName)
      ]
    })
    return items
  },
  getSubmissionValidations () {
    /**
     * @Return {Array}
     */
    const submissionValidations = this.submission.validationResult?.validations || []
    return this.translateValidationValues(submissionValidations, null)
  },
  translateValidationValues (validations, binaryName) {
    /**
     * @Return {Array}
     */
    return validations.map(v => {
      return {
        binary: binaryName,
        title: this.getErrorMessage(v.errorMessage),
        info: this.getErrorInfo(v.errorInfo),
        description: this.getErrorDescription(v.errorMessage),
        ...v
      }
    })
  },
  relateValidationObjects (validations) {
    const validationsObj = []
    I18nKeys.VALIDATION_ERRORS.forEach(name => {
      const warnItems = validations.filter(v => v.errorLevel === 'WARN')
      const okItems = validations.filter(v => v.errorLevel === 'OK')
      const errorItems = validations.filter(v => v.errorLevel === 'ERROR')
      if (warnItems.length > 0) {
        const items = validations.filter(v => v.errorMessage === name && v.errorLevel === 'WARN')
        const obj = {
          title: this.getInfoMessage(name),
          error: this.getErrorMessage(name),
          items: this.combineSameValidations(this.combineValidationCategories(items)),
          errorLevel: items.length === 0 ? null : items[0].errorLevel
        }
        validationsObj.push(obj)
      }
      if (okItems.length > 0) {
        const items = validations.filter(v => v.errorMessage === name && v.errorLevel === 'OK')
        const obj = {
          title: this.getInfoMessage(name),
          error: this.getErrorMessage(name),
          items: this.combineSameValidations(this.combineValidationCategories(items)),
          errorLevel: items.length === 0 ? null : items[0].errorLevel
        }
        validationsObj.push(obj)
      }
      if (errorItems.length > 0) {
        const items = validations.filter(v => v.errorMessage === name && v.errorLevel === 'ERROR')
        const obj = {
          title: this.getInfoMessage(name),
          error: this.getErrorMessage(name),
          items: this.combineSameValidations(this.combineValidationCategories(items)),
          errorLevel: items.length === 0 ? null : items[0].errorLevel
        }
        validationsObj.push(obj)
      }
      if(warnItems.length <= 0 && errorItems.length <= 0 && okItems.length <= 0) {
        const obj = {
          title: this.getInfoMessage(name),
          error: this.getErrorMessage(name),
          items: [],
          errorLevel: null
        }
        validationsObj.push(obj)
      }
    })
    this.validations = Misc.removeDuplicates(validationsObj, true)
  },
  combineValidationCategories (items) {
    const values = []
    items.map(i => {
      const exists = values.some(v => {
        if (v.binary && i.binary && v.binary === i.binary && v.info?.category === i.info?.category) {
          if (v.info && i.info) {
            v.info.details = (i.info.title === 'Glyph') ? [v.info.details, i.info.details].join(', ') : [v.info.details, i.info.details].join('<br /><br />')
          }
          return true
        }
      })
      if (!exists) {
        values.push(i)
      }
    })
    return values
  },
  combineSameValidations(items) {
    const values = [];
    items.map(i => {
      const exists = values.some(v => {
        if (v.category === i.category && v.info?.details === i.info?.details) {
          if (v.binary && i.binary) {
            v.binary = !Array.isArray(v.binary) ? [v.binary] : v.binary;
            v.binary.push(i.binary);
            return true;
          }
        }
      });
  
      if (!exists) {
        if (i.binary) {
          if (!Array.isArray(i.binary)) {
            i.binary = [i.binary];
          }
        } else {
          i.binary = null;
        }
        values.push(i);
      }
    });
    return values;
  },
  getErrorMessage (name) {
    return this.$t(`pages.submissions.components.validator.error_keys.${name}.error`)
  },
  getInfoMessage (name) {
    return this.$t(`pages.submissions.components.validator.error_keys.${name}.info`)
  },
  getErrorDescription (name) {
    return this.$t(`pages.submissions.components.validator.error_keys.${name}.description`)
  },
  getErrorInfo (errorInfo) {
    const info = Array.isArray(errorInfo) ? [...errorInfo] : [errorInfo]
    const category = info.length > 0 ? Object.keys(info[0])[0] : null
    const multipleDetails = !Array.isArray(info[0]) && Object.keys((info[0] || {})).length > 1
    return category
      ? {
        title: multipleDetails ? '' : this.$t(`pages.submissions.components.validator.info.${category}`),
        category,
        details: this.getErrorInfoDetails(info[0])
      }
      : null
  },
  getErrorInfoDetails (info = {}) {
    const multipleDetails = (typeof info === 'object' && !Array.isArray(info) && Object.keys(info).length > 1)
    let values;
    if (typeof info === 'string') {
      values = [info];
    } else if (Array.isArray(info)) {
      values = [...info];
    } else {
      values = this.formatErrorInfoDetails(info);
    }
    const ret = multipleDetails
      ? values.join('')
      : values.join(', ')
    return ret
  },
  formatErrorInfoDetails (obj = {}) {
    /**
     * @param {Object} obj – Object with info details
     * @returns {Array}
     */
    let ret = []
    const keys = Object.keys(obj)
    if (keys.length === 1) {
      const value = Object.values(obj)[0]
      if (Array.isArray(value)) {
        ret = value
      } else if (typeof value === 'string') {
        ret = [value]
      } else {
        ret = Object.values(value)
      }
    } else {
      const items = keys.map(item => {
        let errorMsg = this.$t(`pages.submissions.components.validator.error_keys.${obj[item]}.error`)
        if (errorMsg === `pages.submissions.components.validator.error_keys.${obj[item]}.error`) {
          errorMsg = obj[item]
        }
        const title = this.$t(`pages.submissions.components.validator.info.${item}`)
        let info;
        if (Array.isArray(obj[item])) {
          info = obj[item].join(', ');
        } else if (item === 'errorReason') {
          info = errorMsg;
        } else {
          info = obj[item];
        }
        return `${title}: ${info}`
      })
      ret = new Array(items.join('<br />'))
    }
    return ret
  }
}